/**
 * Validates 5-digit zipcodes.
 * @param zipcode
 * @returns boolean
 */
export function validateZipcode(zipcode: string): boolean {
  return /^\d{5}$/.test(zipcode);
}
